import React from "react"
import styled from "styled-components"
import { Heading, TextLg, Text } from "@atoms"
import { Link } from "gatsby"
import { theme } from "@theme"
import { wordTime } from "@utils/wordTime"
import { publishDateFormat } from "@utils/text"
import cardPlaceholderImg from "./card-placeholder.jpg"
import { CardContainer } from "./styles/NewsCompanyCard.styled"
import { ConditionalWrapper } from "../../atoms/ConditionalWrapper"

function truncate(input) {
  if (input.length > 130) {
    return input.substring(0, 130) + "..."
  }
  return input
}

function truncateSixty(input) {
  if (input.length > 60) {
    return input.substring(0, 60) + "..."
  }
  return input
}

const noLinkStyles = {
  textDecoration: "none !important",
}

export const NewsCompanyCard = ({ title, description, publishDate, link }) => {
  return (
    <ConditionalWrapper
      condition={link}
      wrapper={children => (
        <Link
          style={{ display: "block", padding: "0px", textDecoration: "none" }}
          to={link}
        >
          {children}
        </Link>
      )}
    >
      <CardContainer data-comp={NewsCompanyCard.displayName} theme={theme}>
        {description && (
          <span>
            <img src="/icons/calendar-gray.svg" alt="calendar" />
            Published on {publishDateFormat(publishDate)}
          </span>
        )}
        {title && (
          <Heading
            headingSize="H6"
            style={{
              color: "#0022B7",
              paddingBottom: "8px",
            }}
          >
            {truncateSixty(title)}
          </Heading>
        )}
        {description && <Text>{truncate(description)}</Text>}
      </CardContainer>
    </ConditionalWrapper>
  )
}

NewsCompanyCard.displayName = "NewsCompanyCard"
